/* global __CLIENT__ */
import i18n from 'i18next';
import Backend from 'i18next-http-backend';

import {
  SUPPORTED_LOCALE_LIST,
  DEFAULT_LOCALE,
} from '@snapask/common-components/dist/constants/locales';
import localeFolderMapping from './constants/localeFolderMapping';

if (__CLIENT__) {
  i18n.use(Backend);
}

const whiteList = Object.keys(SUPPORTED_LOCALE_LIST);

export const config = {
  fallbackLng: DEFAULT_LOCALE,
  load: 'currentOnly',
  lowerCaseLng: true,
  whiteList,
  defaultNS: 'common', // the default value is translation cause 404 , so we have to assign a smallest size ns as default.
  ns: [
    // sort alphabetically
    'account',
    'common',
    'confirmEmail',
    'emailNotVerified',
    'error',
    'fieldLabel',
    'footer',
    'forgotPassword',
    'home',
    'login',
    'mission',
    'navbar',
    'navigation',
    'onboarding',
    'partners',
    'paymentReceipt',
    'premium',
    'privacy',
    'purchase',
    'questionsRemainingModal',
    'resetPassword',
    'seo',
    'studentSignup',
    'terms',
    'tutor',
    'tutorFaq',
    'tutorList',
    'tutorSignup',
  ],
  backend: {
    // loading i18n scripts from static file
    loadPath: (lngs, namespaces) =>
      `/i18n/${localeFolderMapping[lngs[0]]}/${namespaces}.json`,
  },
  react: {
    wait: true,
  },
};

if (!i18n.isInitialized) i18n.init(config);

export default i18n;



// WEBPACK FOOTER //
// ./app/i18n.js